/**
 * 防抖：在函数被触发的n秒内，如果又被触发，就会重新计时；
 * 应用场景：
 * 1. 在input框中输入搜索内容的时候，浏览器不会马上就去执行，
 * 2. 手机号、邮箱输入验证；
 * 3. 窗口大小resize，只需要调整完成后，计算窗口大小，防止重复渲染
*/
export function debounce(fn, time) {
  const delay = time || 200
  let timer = 0
  return function () {
    const self = this
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = 0
      fn.apply(self)
    }, delay)
  }
}

/**
 * 节流：每隔一段时间，只执行一次函数
 * 应用场景：
 * 1. 滚动加载，加载更多或者滚到底部监听
 * 2. 频繁点击按钮
*/
export function throttle(func, threshhold = 160, immediate) {
  let timeout
  let start = new Date()

  return function () {
    const context = this
    const args = arguments
    const curr = new Date() - 0

    clearTimeout(timeout)
    if (curr - start >= threshhold) {
      func.apply(context, args)
      start = curr
    } else if (immediate) {
      timeout = setTimeout(() => {
        func.apply(context, args)
      }, threshhold)
    }
  }
}
